export function potongDuaDigitDesimal(angka: number) {
	let angkaString = angka.toString();
	let indeksKoma = angkaString.indexOf(".");

	if (indeksKoma !== -1) {
		let duaDigitSetelahKoma = angkaString.substring(indeksKoma + 1, indeksKoma + 5);
		return parseFloat(angkaString.substring(0, indeksKoma + 1) + duaDigitSetelahKoma);
	} else {
		return angka;
	}
}

export const floatToPercentageWithFixed = (value?: number, length?: number) => {
	if (!value) return undefined;

	return Number((Number(value) * 100).toFixed(length ?? 2));
};

export const percentageToFloatWithFixed = (value?: number, length?: number) => {
	if (!value) return undefined;

	return Number((Number(value) / 100).toFixed(length ?? 4));
};

export const numberToFloatWithFixed = (value?: number, length?: number) => {
	if (!value) return undefined;

	return Number(Number(value).toFixed(length ?? 2));
};
